/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum NotificationSubjects {
    AlertTaskJob = 1,
    AddedChatMessage = 2,
    InvokedDeviceAction = 3,
    PushedInfo = 4,
    PushedStartedMission = 5,
    AddedIssueEvent = 6,
    SentEditorRequest = 7,
    CreatedTicketSolutionItem = 9,
    CreatedMissionSolutionItem = 10,
    ReceivedIssue = 11,
}
